export default __webpack_public_path__ + "static/media/fast-forward.5a5c2f3e.svg";